const VIEW_REQUEST_LEND_NEW_LOAN_REQUEST = 'DWP.COMM.EQ.GO.NEW.LOAN.REQUEST.LEND';
const VIEW_REQUEST_BORROW_NEW_LOAN_REQUEST = 'DWP.COMM.EQ.GO.NEW.LOAN.REQUEST.BORROW';
const VIEW_REQUEST_UPDATE_EQUIPMENT_STATUS = 'DWP.COMM.EQ.GO.UPDATE.EQUIPMENT.STATUS';
const UPDATE_EQUIPMENT_STATUS_AVAILABLE = 'DWP.COMM.EQ.STATUS.AVAILABLE';
const UPDATE_EQUIPMENT_STATUS_STAND_BY = 'DWP.COMM.EQ.STATUS.STANDBY';
const UPDATE_EQUIPMENT_STATUS_IN_USE = 'DWP.COMM.EQ.STATUS.INUSE';
const UPDATE_EQUIPMENT_STATUS_RETURNING = 'DWP.COMM.EQ.STATUS.RETURNING';
const UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN = 'DWP.COMM.EQ.STATUS.NOTFORLOAN';
const UPDATE_EQUIPMENT_STATUS_REPAIRING = 'DWP.COMM.EQ.STATUS.REPAIRING';
const UPDATE_EQUIPMENT_STATUS_RESERVED = 'DWP.COMM.EQ.STATUS.RESERVED';
const UPDATE_EQUIPMENT_STATUS_CONDEMNED = 'DWP.COMM.EQ.STATUS.CONDEMNED';
const DWP_COMM_REMARK_BMS_S = 'DWP.COMM.REMARK.BMS.S';
const DWP_COMM_REMARK_BMS_M = 'DWP.COMM.REMARK.BMS.M';
const DWP_COMM_REMARK_BMS_L = 'DWP.COMM.REMARK.BMS.L';
const DWP_COMM_REMARK_BMS_ISFA = 'DWP.COMM.REMARK.BMS.ISFA';
const UPDATE_EQUIPMENT_STATUS_REPROCESSING = 'DWP.COMM.EQ.STATUS.REPROCESSING';

export {
  VIEW_REQUEST_LEND_NEW_LOAN_REQUEST,
  VIEW_REQUEST_BORROW_NEW_LOAN_REQUEST,
  VIEW_REQUEST_UPDATE_EQUIPMENT_STATUS,
  UPDATE_EQUIPMENT_STATUS_AVAILABLE,
  UPDATE_EQUIPMENT_STATUS_STAND_BY,
  UPDATE_EQUIPMENT_STATUS_IN_USE,
  UPDATE_EQUIPMENT_STATUS_RETURNING,
  UPDATE_EQUIPMENT_STATUS_NOT_FOR_LOAN,
  UPDATE_EQUIPMENT_STATUS_REPAIRING,
  UPDATE_EQUIPMENT_STATUS_RESERVED,
  UPDATE_EQUIPMENT_STATUS_CONDEMNED,
  DWP_COMM_REMARK_BMS_S,
  DWP_COMM_REMARK_BMS_M,
  DWP_COMM_REMARK_BMS_L,
  DWP_COMM_REMARK_BMS_ISFA,
  UPDATE_EQUIPMENT_STATUS_REPROCESSING,
};
